var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.appClass,attrs:{"id":"app"}},[_c('A11yMenu'),_c('MainHeader',{staticClass:"header"}),_c('MainNav',{staticClass:"navigation",class:{'show':_vm.showNav}}),_c('router-view',{staticClass:"app-vista"}),_c('MainInfo'),_c('ConahcytFooter'),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }